@if (binding != 'number') {
  <div class="bound-label-container">
    <span class="bound-label-value">{{translationsService.translate(labelValue)}}</span>
  </div>
}

@if (binding == 'number') {
  <div class="bound-label-container number-value">
    <span class="bound-label-value">{{labelValue}}</span>
  </div>
}